<template>
  <div v-show="show" class="qrCode">
    <div class="content">
      <div class="qrCodeText">{{ qrCodeText }}</div>
      <div id="qrCode" class="qrCodeImg">
        <div class="qrCodeImgBox">
          <img :src="codeImgUrl" v-if="codeImgUrl" />
          <div class="loading-spinner" v-else>
            <div class="spinner-ring"></div>
            <div class="loading-text">加载中...</div>
          </div>
        </div>
      </div>
      <img @click="close()" class="close" src="@/assets/img/close.png" />
    </div>
  </div>
</template>


<script>
import { mapState } from 'vuex'
export default {
  name: 'reserve-dialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    reserveDialogType: {
      type: String,
      default: 'jump'
    },
    userApplyId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      codeImgUrl: ''
    }
  },
  computed: {
    qrCodeText() {
      let text = '';
      switch (this.reserveDialogType) {
        case 'jump':
          text = '微信扫码 参与免费试用活动';
          break
        case 'reserve':
          text = '微信扫码 提前预约';
          break
        case 'status':
          text = '微信扫码 查看进度';
          break
      }
      return text;
    }
  },

  mounted() {
    console.log(this.reserveDialogType);
    this.getXcxCode();
  },
  created() {
    // this.show = this.store.state.showQrCode ;
  },
  watch: {
  },
  methods: {
    // 获取小程序码
    async getXcxCode() {
      let path, str;

      // 根据类型设置不同的路径和参数
      if (this.reserveDialogType === 'status') {
        path = 'pages/trial/show';
        str = 'aid=' + this.userApplyId;
      } else {
        path = 'pages/trial/info';
        str = 'id=' + this.$route.params.id;
      }

      let res = await this.axios.post(solution_host + '/api/xcx/qrcode', {
        path: path,
        str: str,
        env_version: window.location.host.indexOf('uat.') > -1 ? 'trial' : ''
      })
      if (res.status !== 200) {
        return;
      }
      this.codeImgUrl = res.data.data.src;
    },

    close() {
      this.$emit('update:show', false);
    },
  },
}
</script>

<style lang="scss" scoped>
.qrCode {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 5;
  background-color: rgb(0 0 0 / 42%);

  .content {
    width: 268px;
    height: 328px;
    border-radius: 10px;
    top: 50%;
    left: 50%;
    margin-top: -134px;
    margin-left: -164px;
    background-color: #243F60;
    text-align: center;

    .qrCodeText {
      width: 100%;
      font-size: 14px;
      color: #fff;
      margin-top: 20px;
      margin-bottom: 20px;
      word-break: keep-all;
    }

    .qrCodeImg {
      position: relative;
      margin: 0 auto;
      width: 220px;
      height: 220px;
      border-radius: 50%;
      background-image: url("~@/assets/xcx-code-border.png");
      background-size: 90%;
      background-position: center;

      background-repeat: no-repeat;
      display: flex;
      justify-content: center;
      align-items: center;

      .qrCodeImgBox {
        position: relative;
        top: -2px;
        width: 177px;
        height: 177px;
        overflow: hidden;
        background-color: #fff;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 160px;
        }

        .loading-spinner {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          
          .spinner-ring {
            width: 50px;
            height: 50px;
            border: 4px solid #f3f3f3;
            border-top: 4px solid #243F60;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            margin-bottom: 10px;
          }
          
          .loading-text {
            font-size: 12px;
            color: #666;
            font-weight: 500;
          }
        }
      }
    }
  }

  .close {
    cursor: pointer;
    position: absolute;
    bottom: -40px;
    left: 50%;
    margin-left: -14px;
    width: 28px;
    display: block;
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
